import gql from 'graphql-tag';
export const LoomVideoDurationsQuery = gql`
	query LoomVideoDurationsQuery($id: ID!) {
		loom_videoDurations(id: $id) {
			sourceDuration
			playableDuration
		}
	}
`;
